<template>
  <div v-loading="showFlag">
    <t-card>
      <!-- ボタン -->
      <div :style="{ height: bottomHeight + 'px' }">
        <t-row>
          <t-col :span="24" class="right">
            <!-- 見積依頼書出力ボタン -->
            <t-button
              round
              type="primary"
              class="dialogButton_150_40"
              ref="estimateRequestOutputBtn"
              @click="estimateRequestOutputClick()"
            >
              <i class="el-icon-download"></i
              >{{ $t("resource.NUMBER.ESTIMATE_REQUEST_OUTPUT_BUTTON") }}
            </t-button>
          </t-col>
        </t-row>
      </div>
      <div
        :style="`height: ${detailHeight}px; overflow-y: auto;margin-top:10px`"
      >
        <div v-for="(table, tableIndex) in processTables" :key="tableIndex">
          <div v-if="tableIndex != 0" style="margin-top: 20px">
            <span>{{ table.tittle }}</span>
            <t-switch
              v-model="table.kbn"
              :disabled="tableIndex == 0 || productNotEditFlg"
              style="margin-left: 15px"
            ></t-switch>
          </div>
          <div v-if="table.kbn">
            <div class="div_common_search" style="width: 99%">
              <div style="padding: 0 15px 15px 15px">
                <t-divider>{{ table.tittle }}</t-divider>
                <t-row>
                  <t-col :span="4" class="col_common_left">
                    <!-- 仕入先選択ボタン -->
                    <t-button
                      round
                      type="primary"
                      class="dialogButton_150_40"
                      :ref="'supplierReferenceBtn' + tableIndex"
                      @click="supplierReferenceClick(tableIndex)"
                      :disabled="productNotEditFlg"
                    >
                      <i class="el-icon-s-order"></i
                      >{{ $t("resource.NUMBER.SUPPLIER_SELECT_BUTTON") }}
                    </t-button>
                  </t-col>
                </t-row>
                <div>
                  <t-table
                    v-if="products.length > 0"
                    ref="products"
                    :data="products"
                    class="table_common"
                    header-cell-class-name="bg-default"
                    highlight-current-row
                    :max-height="maxHeight"
                    :cell-class-name="
                      (rowData) => {
                        return tableCellClassName(rowData, tableIndex);
                      }
                    "
                    border
                  >
                    <!-- 処理有無 -->
                    <t-table-column
                      :label="$t('resource.NUMBER.PROCESSING')"
                      width="80"
                      align="center"
                      header-align="center"
                      v-if="tableIndex != 0"
                    >
                      <template #default="scope">
                        <t-switch
                          v-model="table.qrProcKbnFlag[scope.$index]"
                          :disabled="productNotEditFlg"
                          active-value="2"
                          inactive-value="1"
                        >
                          <!-- :active-text="$t('resource.button.yes')"
                          :inactive-text="$t('resource.button.no')" -->
                        </t-switch>
                      </template>
                    </t-table-column>

                    <!-- 製品テーブルの列 -->
                    <t-table-column
                      v-for="(column, index) in supplierTableColumns"
                      :key="column.prop || index"
                      :type="column.type"
                      :prop="column.prop"
                      :label="column.label"
                      :min-width="column.width"
                      :class-name="column.class"
                      :fixed="column.fixed"
                      :show-overflow-tooltip="column.overflowTooltip"
                    >
                    </t-table-column>

                    <!-- 仕入先テーブルの列 -->
                    <t-table-column
                      v-for="(column, index) in table.supplierCodeAndName"
                      :key="index"
                      :prop="'newColumn' + column.supCode"
                      :label="column.supName"
                      min-width="180"
                      class-name="cell_txt_right"
                    >
                      <template #default="scope">
                        <t-input
                          class="cell_input_custom"
                          v-if="
                            editCellData(tableIndex, scope.row, scope.column)
                          "
                          :disabled="table.qrProcKbnFlag[scope.$index] == '1'"
                          maxLength="9"
                          :value="
                            getPrice(
                              tableIndex,
                              scope.row.ndProdNo,
                              column.supCode
                            )
                          "
                          @focus="
                            handleFocus(
                              tableIndex,
                              scope.row.ndProdNo,
                              column.supCode,
                              $event.target.value
                            )
                          "
                          @input="
                            handleInput(
                              tableIndex,
                              scope.row.ndProdNo,
                              column.supCode,
                              $event
                            )
                          "
                          @blur="
                            changeCellData(
                              tableIndex,
                              scope.row.ndProdNo,
                              column.supCode
                            )
                          "
                          :ref="`input-${tableIndex}-${scope.row.index}-${scope.column.property}`"
                          @keyup.native.enter="
                            focusNextInput(
                              tableIndex,
                              scope.row.index,
                              scope.column.property
                            )
                          "
                        ></t-input>

                        <!-- @blur="
                            changeCellData(
                              tableIndex,
                              scope.row.ndProdNo,
                              column.supCode,
                              $event.target.value
                            )
                          " -->

                        <!--<t-input-number
                          class="cell_input_number"
                          v-if="
                            editCellData(tableIndex, scope.row, scope.column)
                          "
                          :disabled="table.qrProcKbnFlag[scope.$index] == '1'"
                          :controls="false"
                          :precision="2"
                          :min="0"
                          :max="999999.99"
                          :value="
                            getPrice(
                              tableIndex,
                              scope.row.ndProdNo,
                              column.supCode
                            )
                          "
                          @blur="
                            changeCellData(
                              tableIndex,
                              scope.row.ndProdNo,
                              column.supCode,
                              $event.target.value
                            )
                          "
                        /> -->

                        <span v-else>
                          {{
                            getPrice(
                              tableIndex,
                              scope.row.ndProdNo,
                              column.supCode
                            )
                          }}
                        </span>
                      </template>
                    </t-table-column>
                    <!-- 仕入先選択列 -->
                    <t-table-column
                      :label="$t('resource.NUMBER.SUPPLIER_SELECT')"
                      min-width="150"
                      align="center"
                      v-if="table.selectSupCode.length > 0"
                      header-align="center"
                    >
                      <template #default="scope">
                        <t-select
                          v-model="table.selectSupCode[scope.$index]"
                          clearable
                          class="commonDialog"
                          placeholder=""
                          :disabled="
                            productNotEditFlg ||
                            table.qrProcKbnFlag[scope.$index] == '1'
                          "
                        >
                          <t-option
                            v-for="item in table.supplierCodeAndName"
                            :key="item.supCode"
                            :label="
                              (item.supCode + ':' + item.supName).split('(')[0]
                            "
                            :value="item.supCode"
                          >
                          </t-option>
                        </t-select>
                      </template>
                    </t-table-column>
                  </t-table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- ボタン -->
      <div :style="{ height: bottomHeight + 'px' }">
        <t-row>
          <t-col :span="24" class="right">
            <!-- 確定ボタン -->
            <t-button
              round
              type="warning"
              class="dialogButton_confirm_120_40"
              ref="confirmBtn"
              :disabled="productNotEditFlg"
              @click="confirmClick()"
            >
              <i class="el-icon-check"></i>
              {{ $t("resource.sys.sure") }}
            </t-button>
          </t-col>
        </t-row>
      </div>
    </t-card>
  </div>
</template>
<script>
import { getUserInfo } from "@/auth";
import { ShowSupplierReferenceDialog } from "@/components/Dialog";
import { t } from "@/locales";
import {
  editNumberInfoByProcessing,
  searchNumberDetailProcessingByNbQuoteNo,
} from "@/services/number";
import {
  cmpDetailData,
  getDialogContentHeight,
  moneyFormat,
} from "@/utils/comFunction";
import {
  DIALOG_LINE_HEIGHT,
  NB_PROC_KBN_ELSE,
  NB_PROC_KBN_FALSE,
  NB_PROC_KBN_TRUE,
  QR_PROC_KBN_FLAG_NOT_SELECTED,
  QR_PROC_KBN_FLAG_SELECTED,
  STR_EMPTY,
} from "@/utils/const";

import { Message, Modal } from "@tellus/component";
export default {
  data() {
    return {
      //比較用明細情報
      cmpDetailResult: {},

      //明細情報のheight
      detailHeight: getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT * 1,
        10
      ),

      //合計情報のheight
      bottomHeight: DIALOG_LINE_HEIGHT * 1,

      maxHeight: 280,

      //データの更新時刻
      nbUpdateTime: null,

      //加工のテーブル
      supplierTable: [],
      //加工のテーブルの列
      supplierTableColumns: [
        {
          prop: "ndProdName",
          label: t("resource.COMMON_CONSTANT.PRODUCT_NAME"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          fixed: true,
          overflowTooltip: true,
        },
        {
          prop: "ndProdDrawNo",
          label: t("resource.COMMON_CONSTANT.PICTURE_NO"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_left",
          fixed: true,
          overflowTooltip: true,
        },
        {
          prop: "ndProdQuantity",
          label: t("resource.COMMON_CONSTANT.COUNT"),
          width: t("widgetSize.tableCommon.defaultWidth"),

          class: "cell_txt_right",
          fixed: true,
        },
        {
          prop: "ndProdUnit",
          label: t("resource.COMMON_CONSTANT.UNIT"),
          width: t("widgetSize.tableCommon.defaultWidth"),
          class: "cell_txt_center",
          fixed: true,
          overflowTooltip: true,
        },
      ],

      //製品情報
      products: [],
      //加工プロセスの詳細情報
      processTables: [
        {
          tittle: t("resource.NUMBER.MAIN_PROCESSING"),
          kbn: true,
          supplierCodeAndName: [],
          quoteRequests: [],
          selectSupCode: [],
          qrProcKbnFlag: [],
        },
        {
          tittle: t("resource.NUMBER.PROCESSING_ONE"),
          kbn: false,
          supplierCodeAndName: [],
          quoteRequests: [],
          selectSupCode: [],
          qrProcKbnFlag: [],
        },
        {
          tittle: t("resource.NUMBER.PROCESSING_TWO"),
          kbn: false,
          supplierCodeAndName: [],
          quoteRequests: [],
          selectSupCode: [],
          qrProcKbnFlag: [],
        },
        {
          tittle: t("resource.NUMBER.PROCESSING_THREE"),
          kbn: false,
          supplierCodeAndName: [],
          quoteRequests: [],
          selectSupCode: [],
          qrProcKbnFlag: [],
        },
      ],
      supplierCodeAndNameBak: [],

      //処理スイッチ
      kbnArr: [],

      //カバー層のフラップ false:表示しない
      showFlag: false,
    };
  },

  props: {
    nbQuoteNo: {
      Type: String,
    },
    nbProcKbn: {
      Type: String,
    },
    nbQuoteDate: {
      Type: String,
    },
    productNotEditFlg: {
      Type: Boolean,
    },
  },

  mounted() {
    this.init();
    //テーブルの高さを監視する
    window.addEventListener("resize", this.handleResize);
  },

  methods: {
    // 初期化
    init() {
      this.showFlag = true;
      this.setInitValue();
      this.searchNumberDetailProcessingByNbQuoteNoProc();
    },

    //検索
    searchNumberDetailProcessingByNbQuoteNoProc() {
      //見積No.による採番詳細処理情報の取得
      searchNumberDetailProcessingByNbQuoteNo({
        nbQuoteNo: this.nbQuoteNo,
      })
        .then((res) => {
          this.nbUpdateTime = res.nbUpdateTime;
          this.supplierCodeAndNameBak = [];
          //製品情報
          this.products = res.processingView.productInfos;

          //処理スイッチのクリア
          this.kbnArr = [];
          for (var i = 0; i < res.processingView.processingData.length; i++) {
            // 仕入先コードと仕入先名
            this.processTables[i].supplierCodeAndName =
              res.processingView.processingData[i].supplierCodeAndName;
            this.supplierCodeAndNameBak.push(
              this.processTables[i].supplierCodeAndName.map(
                (item) => item.supCode
              )
            );

            //仕入先価格
            this.processTables[i].quoteRequests =
              res.processingView.processingData[i].supplierPrice;
            //金銭書式設定
            for (
              let j = 0;
              j < this.processTables[i].quoteRequests.length;
              j++
            ) {
              this.processTables[i].quoteRequests[j].qrSupPrice = moneyFormat(
                this.processTables[i].quoteRequests[j].qrSupPrice,
                2,
                ".",
                ","
              );
            }

            //選択した「仕入先コード」
            this.processTables[i].selectSupCode =
              res.processingView.processingData[i].selectSupCode;

            //処理有無
            this.processTables[i].qrProcKbnFlag =
              res.processingView.processingData[i].qrProcKbnFlag;

            //処理スイッチ
            this.kbnArr.push(res.processingView.processingData[i].kbn);
          }

          this.supplierCodeAndNameBak.flat(Infinity);

          this.dataProcess();
        })
        .catch((err) => {
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(
              t("message.COMMON_MESSAGE.DETAIL_SEARCH_FAILURE")
            );
          }
        })
        .finally(() => {
          this.showFlag = false;
        });
    },

    dataProcess() {
      //比較用詳細情報
      this.cmpDetailResult = JSON.parse(JSON.stringify(this.processTables));
    },

    //初期値の設定
    setInitValue() {
      for (var i = 0; i < 4; i++) {
        this.processTables[i].kbn =
          this.nbProcKbn.split("")[i] == NB_PROC_KBN_TRUE ? true : false;
      }
    },

    //テーブルの高さを設定する
    handleResize() {
      this.detailHeight = getDialogContentHeight(
        window.innerHeight,
        DIALOG_LINE_HEIGHT * 1,
        DIALOG_LINE_HEIGHT * 1,
        10
      );
    },

    //仕入先選択ボタン
    supplierReferenceClick(tableIndex) {
      //["220","221"……]
      var supData = this.processTables[tableIndex].supplierCodeAndName.map(
        (supplier) => supplier.supCode
      );

      ShowSupplierReferenceDialog(
        { tableIndex: tableIndex, type: "supplierSelect", supData: supData },
        t("resource.NUMBER.SUPPLIER_SELECT_VIEW"),
        (target) => {
          if (typeof target != "undefined") {
            //「;」で分割する、 例：220:仕入先A(JPY);221:仕入先B(CNY) ⇒ [220:仕入先A(JPY),221:仕入先B(CNY)]
            var arr = target.split(";");

            // 仕入先コードと仕入先名
            this.processTables[tableIndex].supplierCodeAndName = [];
            for (var i = 0; i < arr.length; i++) {
              var supCode = arr[i].split(":")[0];
              var supName = arr[i].split(":")[1];

              this.processTables[tableIndex].supplierCodeAndName.push({
                supCode: supCode,
                supName: supName,
              });
            }

            //選択した「仕入先コード」
            this.processTables[tableIndex].selectSupCode = [];
            for (var i = 0; i < this.products.length; i++) {
              this.processTables[tableIndex].selectSupCode.push("");
            }

            //仕入先価格
            var quoteRequestsTmp = this.processTables[tableIndex].quoteRequests;
            this.processTables[tableIndex].quoteRequests = [];

            //初期値を空にする
            for (var i = 0; i < this.products.length; i++) {
              for (
                var j = 0;
                j < this.processTables[tableIndex].supplierCodeAndName.length;
                j++
              ) {
                this.processTables[tableIndex].quoteRequests.push({
                  qrProdNo: this.products[i].ndProdNo,
                  qrSupCode:
                    this.processTables[tableIndex].supplierCodeAndName[j]
                      .supCode,
                  qrSupPrice: STR_EMPTY,
                });
              }
            }

            //変更前の値を代入
            this.$nextTick(() => {
              this.processTables[tableIndex].quoteRequests.forEach((item) => {
                var price = quoteRequestsTmp.find(
                  (tmp) =>
                    tmp.qrProdNo == item.qrProdNo &&
                    tmp.qrSupCode == item.qrSupCode
                )?.qrSupPrice;

                if (price != undefined) {
                  item.qrSupPrice = price;
                }
              });
            });
          }
        }
      );

      // フォーカス削除
      this.$refs["supplierReferenceBtn" + tableIndex][0].$el.blur();
    },

    //見積依頼書出力ボタン
    estimateRequestOutputClick() {
      //チェック
      var tmpArr = [];
      for (var i = 0; i < this.processTables.length; i++) {
        tmpArr.push(
          this.processTables[i].supplierCodeAndName.map((item) => item.supCode)
        );
      }
      tmpArr.flat(Infinity);

      //単語ごとに分割
      var tmpArrData = JSON.stringify(tmpArr);
      var supplierCodeAndNameBakData = JSON.stringify(
        this.supplierCodeAndNameBak
      );

      //変化がある場合
      if (
        tmpArrData.split("").length !=
        supplierCodeAndNameBakData.split("").length
      ) {
        Modal.showWarning("", t("message.NUMBER.DATA_SAVE_FIRST"), {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
        return;
      } else {
        for (var i = 0; i < tmpArrData.split("").length; i++) {
          if (
            JSON.stringify(tmpArrData[i]) !=
            JSON.stringify(supplierCodeAndNameBakData[i])
          ) {
            Modal.showWarning("", t("message.NUMBER.DATA_SAVE_FIRST"), {
              confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
            });
            return;
          }
        }
      }

      //処理テーブルのswitchを変更したかどうかを判断する
      var kbnArrTmp = [];
      for (var i = 0; i < this.processTables.length; i++) {
        //画面の処理テーブルのswitchを取得する
        kbnArrTmp.push(this.processTables[i].kbn);
      }

      for (var i = 0; i < this.processTables.length; i++) {
        //変更があるの場合
        if (this.kbnArr[i] != kbnArrTmp[i]) {
          Modal.showWarning("", t("message.NUMBER.DATA_SAVE_FIRST"), {
            confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
          });
          return;
        }
      }

      //すべての選択の仕入先
      var supDataAll = [];
      for (var i = 0; i < this.processTables.length; i++) {
        if (this.processTables[i].kbn) {
          var supData = this.processTables[i].supplierCodeAndName.map(
            (supplier) => supplier.supCode
          );
          supDataAll.push({
            tableIndex: i,
            supData: supData,
          });
        } else {
          supDataAll.push({
            tableIndex: i,
            supData: [],
          });
        }
      }

      ShowSupplierReferenceDialog(
        {
          //tableIndex: tableIndex,
          type: "estimateRequestOutput",
          supDataAll: supDataAll,
          nbQuoteNo: this.nbQuoteNo,
          nbUpdateTime: this.nbUpdateTime,
        },
        t("resource.NUMBER.ESTIMATE_REQUEST_OUTPUT_VIEW"),
        (target) => {
          this.searchNumberDetailProcessingByNbQuoteNoProc();
        }
      );

      // フォーカス削除
      this.$refs.estimateRequestOutputBtn.$el.blur();
    },

    //セルの編集
    editCellData(tableIndex, row, column, cell, event) {
      //受注済みの場合、編集不可
      if (this.productNotEditFlg) {
        return false;
      }
      //「仕入先」のみ編集可
      if (
        !(column.property && column.property.toString().includes("newColumn"))
      ) {
        return false;
      }
      return true;
    },

    //セルの保存
    changeCellData(tableIndex, prodNo, supCode) {
      //新しく入力した値を表のセルにバインドする
      for (
        let index = 0;
        index < this.processTables[tableIndex].quoteRequests.length;
        index++
      ) {
        const element = this.processTables[tableIndex].quoteRequests[index];

        if (element.qrProdNo == prodNo && element.qrSupCode == supCode) {
          this.processTables[tableIndex].quoteRequests[index].qrSupPrice =
            moneyFormat(
              this.processTables[tableIndex].quoteRequests[index].qrSupPrice,
              2,
              ".",
              ","
            );
        }
      }
    },

    //入力ボックスの値の更新
    handleInput(tableIndex, prodNo, supCode, newPrice) {
      newPrice = this.formatAmounts(newPrice.replace(",", ""));

      //新しく入力した値を表のセルにバインドする
      for (
        let index = 0;
        index < this.processTables[tableIndex].quoteRequests.length;
        index++
      ) {
        const element = this.processTables[tableIndex].quoteRequests[index];

        if (element.qrProdNo == prodNo && element.qrSupCode == supCode) {
          this.processTables[tableIndex].quoteRequests[index].qrSupPrice =
            newPrice;
        }
      }
    },

    //入力ボックス値の「,」の削除
    handleFocus(tableIndex, prodNo, supCode, newPrice) {
      //新しく入力した値を表のセルにバインドする
      for (
        let index = 0;
        index < this.processTables[tableIndex].quoteRequests.length;
        index++
      ) {
        const element = this.processTables[tableIndex].quoteRequests[index];

        if (element.qrProdNo == prodNo && element.qrSupCode == supCode) {
          this.processTables[tableIndex].quoteRequests[index].qrSupPrice =
            newPrice.replace(".00", "").replace(/,/g, "");
        }
      }
    },

    formatAmounts(amountStr) {
      let cleanedStr = amountStr.match(/\d+(\.\d{0,2})?/)
        ? amountStr.match(/\d+(\.\d{0,2})?/)[0]
        : "";
      return cleanedStr;
    },

    //確定ボタン
    confirmClick() {
      var checkRes = this.inputCheck();

      //入力チェック
      if (checkRes == STR_EMPTY) {
        this.editNumberInfoByProcessingProc();
      } else {
        Modal.showWarning("", checkRes, {
          confirmButtonText: t("resource.COMMON_CONSTANT.CONFIRM"),
        });
      }

      // フォーカス削除
      this.$refs.confirmBtn.$el.blur();
    },

    //更新
    editNumberInfoByProcessingProc() {
      //画面のデータ
      var tmpProcessingData = [];
      for (var i = 0; i < this.processTables.length; i++) {
        tmpProcessingData.push({
          kbn: this.processTables[i].kbn,
          supplierCodeAndName: this.processTables[i].supplierCodeAndName,
          supplierPrice: this.processTables[i].quoteRequests,
          selectSupCode: this.processTables[i].selectSupCode,
          qrProcKbnFlag: this.processTables[i].qrProcKbnFlag,
        });
      }
      //プロセス区分
      var tmpNbProcKbn = STR_EMPTY;
      for (var i = 0; i < this.processTables.length; i++) {
        tmpNbProcKbn =
          tmpNbProcKbn +
          (this.processTables[i].kbn ? NB_PROC_KBN_TRUE : NB_PROC_KBN_FALSE);
      }
      tmpNbProcKbn = tmpNbProcKbn + NB_PROC_KBN_ELSE;

      //保存する
      editNumberInfoByProcessing({
        nbQuoteNo: this.nbQuoteNo,
        user: getUserInfo().UserId,
        nbUpdateTime: this.nbUpdateTime,
        nbQuoteDate: this.nbQuoteDate,
        nbProcKbn: tmpNbProcKbn,
        processingView: {
          productInfos: this.products,
          processingData: tmpProcessingData,
        },
      })
        .then((res) => {
          Message.showSuccess(t("message.COMMON_MESSAGE.UPDATE_SUCCESS"));
          this.searchNumberDetailProcessingByNbQuoteNoProc();
        })
        .catch((err) => {
          this.showFlag = false;
          if (err.data != null) {
            Message.showError(
              t("message.COMMON_MESSAGE." + err.data.Messages[0].Message)
            );
          } else {
            Message.showError(t("message.COMMON_MESSAGE.UPDATE_FAILURE"));
          }
        });
    },

    //入力チェック
    inputCheck() {
      //すべての製品が「無」を選択した場合
      for (var i = 0; i < this.processTables.length; i++) {
        if (
          this.processTables[i].kbn &&
          this.processTables[i].qrProcKbnFlag.every(
            (item) => item == QR_PROC_KBN_FLAG_NOT_SELECTED
          )
        ) {
          if (i == 1) {
            return t("message.NUMBER.PROCESS_ONE_PRODUCT_NONE");
          } else if (i == 2) {
            return t("message.NUMBER.PROCESS_TWO_PRODUCT_NONE");
          } else if (i == 3) {
            return t("message.NUMBER.PROCESS_THREE_PRODUCT_NONE");
          }
        }
      }

      //仕入先が選択されていない場合
      for (var i = 0; i < this.processTables.length; i++) {
        if (this.processTables[i].kbn) {
          for (var j = 0; j < this.products.length; j++) {
            if (
              this.processTables[i].qrProcKbnFlag[j] ==
                QR_PROC_KBN_FLAG_SELECTED &&
              this.processTables[i].supplierCodeAndName.length == 0
            ) {
              if (i == 0) {
                return t("message.NUMBER.MAIN_PROCESS_SUPPLIER_NONE");
              } else if (i == 1) {
                return t("message.NUMBER.PROCESS_ONE_SUPPLIER_NONE");
              } else if (i == 2) {
                return t("message.NUMBER.PROCESS_TWO_SUPPLIER_NONE");
              } else if (i == 3) {
                return t("message.NUMBER.PROCESS_THREE_SUPPLIER_NONE");
              }
            }
          }
        }
      }

      return STR_EMPTY;
    },

    //セルの配置
    tableCellClassName({ row, column, rowIndex, columnIndex }, tableIndex) {
      row.index = rowIndex;
      column.index = columnIndex;

      //受注済みの場合、処理無の場合編集不可
      if (
        this.productNotEditFlg ||
        this.processTables[tableIndex].qrProcKbnFlag[rowIndex] == "1"
      ) {
        return "";
      }
      if (column.property && column.property.toString().includes("newColumn")) {
        //編集可能の背景色
        return "bg-cell-editable";
      }
    },

    //仕入先の価格の取得
    getPrice(tableIndex, prodNo, supCode) {
      for (
        let index = 0;
        index < this.processTables[tableIndex].quoteRequests.length;
        index++
      ) {
        const element = this.processTables[tableIndex].quoteRequests[index];

        if (element.qrProdNo == prodNo && element.qrSupCode == supCode) {
          // return element.qrSupPrice
          //   ? moneyFormat(element.qrSupPrice, 2, ".", ",")
          //   : "0.00";

          //return moneyFormat(element.qrSupPrice, 2, ".", ",");

          return element.qrSupPrice == "0.00" || element.qrSupPrice == 0
            ? ""
            : element.qrSupPrice;
        }
      }

      return "";
    },

    //Enter処理
    focusNextInput(tableIndex, index, columnProp) {
      index = index + 1;

      if (index > this.products.length - 1) {
        for (var i = 0; i < this.products.length; i++) {
          if (
            this.$refs[`input-${tableIndex}-${i}-${columnProp}`] !==
              undefined &&
            !this.$refs[`input-${tableIndex}-${i}-${columnProp}`][0].disabled
          ) {
            this.$refs[`input-${tableIndex}-${i}-${columnProp}`][0].focus();

            break;
          }
        }
      } else {
        for (var i = index; i < this.products.length; i++) {
          if (
            this.$refs[`input-${tableIndex}-${i}-${columnProp}`] !==
              undefined &&
            !this.$refs[`input-${tableIndex}-${i}-${columnProp}`][0].disabled
          ) {
            this.$refs[`input-${tableIndex}-${i}-${columnProp}`][0].focus();
            break;
          }
        }
      }
    },

    //ダイアログを閉じる
    onCancel() {
      //テーブルのqrSupPrice: ""⇒0
      this.processTables.map((item) => {
        for (var i = 0; i < item.quoteRequests.length; i++) {
          if (item.quoteRequests[i].qrSupPrice == "") {
            item.quoteRequests[i].qrSupPrice = 0;
          }
        }
        return item;
      });

      if (!cmpDetailData(this.cmpDetailResult, this.processTables)) {
        return new Promise((resolve, reject) => {
          Modal.showWarning(
            "",
            t("message.COMMON_MESSAGE.DATA_ALREADY_CHANGED_CLOSE"),
            {
              $type: "prompt",
              confirmButtonText: t("resource.button.sure"),
              cancelButtonText: t("resource.button.cancel"),
              showCancelButton: true,
            }
          )
            .then(() => {
              // 用户点击确认
              resolve(true);
            })
            .catch((error) => {
              // 用户点击取消或关闭对话框
              resolve(false);
            });
        });
      } else {
        return true;
      }
    },
  },
};
</script>
<style scoped>
::v-deep .el-table .current-row > td {
  background-color: #b2d8ff;
}
.el-form-item {
  margin-bottom: 5px;
}

.editCell {
  width: 100%;
  height: 17px;
  line-height: 0;
}
</style>
